import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { debugLogger } from '@/utils/debugLogger';

interface UserTypeCounts {
  all: number;
  sponsors: number;
  sponsored: number;
  free: number;
  standard: number;
  premium: number;
  active: number;
  pending: number;
  hidden: number;
  admins: number;
  test: number;
}

export const useUserTypeCounts = () => {
  return useQuery<UserTypeCounts>({
    queryKey: ['user-type-counts'],
    queryFn: async () => {
      debugLogger.debug('[useUserTypeCounts] Fetching counts...');
      
      const { data, error } = await supabase.rpc('get_user_type_counts');
      
      if (error) {
        debugLogger.error('[useUserTypeCounts] Error fetching counts', error);
        throw error;
      }
      
      debugLogger.debug('[useUserTypeCounts] Counts fetched:', data);
      
      // Parse o JSONB retornado
      if (typeof data === 'object' && data !== null) {
        return data as unknown as UserTypeCounts;
      }
      
      // Fallback se não houver dados
      return {
        all: 0,
        sponsors: 0,
        sponsored: 0,
        free: 0,
        standard: 0,
        premium: 0,
        active: 0,
        pending: 0,
        hidden: 0,
        admins: 0,
        test: 0,
      };
    },
    staleTime: 1000 * 60 * 5, // 5 minutos
    refetchInterval: 1000 * 60 * 5, // Refetch a cada 5 minutos
  });
};
